import { render } from "./ReadingEditGrid.vue?vue&type=template&id=18ffe5c8&scoped=true"
import script from "./ReadingEditGrid.vue?vue&type=script&lang=js"
export * from "./ReadingEditGrid.vue?vue&type=script&lang=js"

import "./ReadingEditGrid.vue?vue&type=style&index=0&id=18ffe5c8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ffe5c8"]])

export default __exports__